export const config = {
  testnet: {
    credenza: {
      apiUrl: "https://api.testnets.credenza.online",
      generalWssUrl: "wss://general-staging-staging.up.railway.app",
      evmWssUrl: "wss://evm-staging-staging.up.railway.app",
      gitbookUrl: `https://developer.credenza3.com/credenza-sdk-v3.0/`,
      evmApiUrl: "https://evm.staging.credenza3.com",
      suiApiUrl: "https://sui.staging.credenza3.com",
      generalApiUrl: "https://api.staging.credenza3.com",
      accountsApiUrl: "https://accounts-staging-staging.up.railway.app",
      oauthUiUri: "https://auth.staging.credenza3.com",
    },
  },
  mainnet: {
    credenza: {
      accountsApiUrl: "https://accounts.credenza3.com",
      apiUrl: "https://api.credenza.online",
      generalApiUrl: "https://api.credenza3.com",
      gitbookUrl: `https://developer.credenza3.com/credenza-sdk-v3.0/`,
      evmApiUrl: "https://evm.credenza3.com",
      suiApiUrl: "https://sui.credenza3.com",
      generalWssUrl: "wss://general-prod-prod.up.railway.app",
      evmWssUrl: "wss://evm-prod-prod.up.railway.app",
      oauthUiUri: "https://auth.credenza3.com",
    },
  },
};
